<template>
  <div class="box">
    <div class="info">
      <!-- icon-audit-touxiang66dark  icon-audit-touxiang66 -->
      <i class="icon icon-audit-touxiang66dark"></i>
      <span v-if="hiddenRemove" @click="handleClickRemove" class="size">×</span>
    </div>
    <div v-if="hiddenArrow" class="arrow">
      <i class="icon icon-audit-jiantou32"></i>
    </div>
    <div class="slot">
      <slot name="username" />
      <slot name="update" />
    </div>
  </div>
</template>

<script>
export default {
  name: "flow",
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    },
    hiddenArrow: {
      type: Boolean,
      default: true
    },
    hiddenRemove: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  components: {},
  created() {},
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    handleClickRemove() {
      this.$emit("handleClickFlowRemove", this.model);
    }
  },
  beforeDestroy() {}
};
</script>

<style scoped>
.box {
  position: relative;
  margin: 10px 10px 0 0;
  width: 130px;
  float: left;
}
.box .info,
.box .arrow {
  position: relative;
  display: inline-block;
  text-align: center;
}
.box .info {
  width: 80px;
}
.box .arrow {
  width: 40px;
}
.box .info i {
  width: 50px;
  height: 50px;
  margin: 5px;
}
.box .arrow i {
  width: 30px;
  height: 20px;
  margin: 0 auto;
}
.box .info .size {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #666666;
  color: aliceblue;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
.box:hover .size {
  display: block;
}
.box .slot {
  width: 80px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// components/flow/index.vue